export default "__VITE_ASSET__Delmuq4M__"